"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormSubmissionFailureTypes;
(function (FormSubmissionFailureTypes) {
    FormSubmissionFailureTypes[FormSubmissionFailureTypes["InValidForm"] = 0] = "InValidForm";
    FormSubmissionFailureTypes[FormSubmissionFailureTypes["PostError"] = 1] = "PostError";
    FormSubmissionFailureTypes[FormSubmissionFailureTypes["PutError"] = 2] = "PutError";
})(FormSubmissionFailureTypes || (FormSubmissionFailureTypes = {}));
exports.default = FormSubmissionFailureTypes;
